import {
	GovCard,
	GovFlex,
	GovGridItem,
	GovTag,
} from '@gov-design-system-ce/react';
import { useLocale } from '@gov-nx/core/service';
import type { PageCode, SearchAllTypesResult } from '@gov-nx/module/page';
import { getTagLabel } from '@gov-nx/module/page';
import { LayoutGap, SearchItemActionResolver } from '@gov-nx/ui/web';
import { FavoriteToggle } from '../../Favorite/FavoriteToggle';

interface SearchResultsGridItemProps {
	item: SearchAllTypesResult;
	code: PageCode;
}

export const SearchResultsGridItem = ({
	item,
	code,
}: SearchResultsGridItemProps) => {
	const { t } = useLocale(code);

	return (
		<GovGridItem column="12">
			<GovCard className="cursor-pointer hover:shadow-(--shadow-m) hover:translate-y-[-2px] hover:transition-all hover:duration-150 hover:ease-in-out">
				<SearchItemActionResolver
					action={item.action}
					link={item.link}
					ariaLabel={item.titleForSorting}>
					<LayoutGap
						gap="s"
						className="w-full">
						<GovFlex
							justifyContent="space-between"
							alignItems="flex-start"
							responsive="false">
							<h3
								className="text-headline-s! text-(--text-primary-color) rich-html"
								dangerouslySetInnerHTML={{
									__html: item.title,
								}}
							/>
							{item.code && (
								<FavoriteToggle
									size="m"
									code={item.code}
									name={item.title}
								/>
							)}
						</GovFlex>
						<div
							className="text-(--text-secondary) rich-html"
							dangerouslySetInnerHTML={{
								__html: item.description,
							}}
						/>
						<GovTag
							color="secondary"
							type="subtle"
							size="xs">
							{getTagLabel(item.type, t)}
						</GovTag>
					</LayoutGap>
				</SearchItemActionResolver>
			</GovCard>
		</GovGridItem>
	);
};
